export const UPDATE_SUPERUSER= 'UPDATE_SUPERUSER'
export const UPDATE_SUPERUSER_SUCCESS= 'UPDATE_SUPERUSER_SUCCESS'
export const UPDATE_SUPERUSER_ERROR='UPDATE_SUPERUSER_ERROR'

export const UpdateSuperUser= (data) => ({
    type: UPDATE_SUPERUSER,
    payload: data
})